#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"
#import "~/graphql/fragments/Components/ContentBlocks.graphql"
#import "~/graphql/fragments/Entry/DefaultHero.graphql"

fragment Overview on overview_Entry {
    title

    contentBlocks {
        ... ContentBlocks
    }

    # Footer Flags
    newsletterSignupVisible
    ctaCardsVisible

    # HEROES
    defaultHero {
        ... DefaultHero
    }

    # Card Details
    cardDetails {
        title: cardTitle
        description: cardDescription
        image: cardImage {
            ... DefaultImageAsset
        }
    }
}
